// add aria-hidden="true" on all br tags

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('br').forEach(function (br) {
    br.setAttribute('aria-hidden', 'true');
  });
});

//th broken aria-label issue fix "aria-labelled by removed

window.addEventListener('load', function () {
  document.querySelectorAll('[aria-labelledby]').forEach(function (el) {
    const refId = el.getAttribute('aria-labelledby');

    if (!document.getElementById(refId)) {
      el.removeAttribute('aria-labelledby');
    }
  });
});
 // Social and External link warning Fixed
document.addEventListener("DOMContentLoaded", function () {
  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = " Redirecting to a third-party website,opens in a new tab.";

  const links = document.querySelectorAll('a[href^="http://"], a[href^="https://"]');

  links.forEach(function (link) {
    const linkHost = link.hostname.replace('www.', '');

    if (linkHost === currentHost || !linkHost) return;

    let linkText = link.textContent.trim();

    if (!linkText) {
      const img = link.querySelector('img');
      const imgAlt = img ? img.getAttribute('alt') : null;
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    const currentAriaLabel = link.getAttribute('aria-label');

    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;

    link.setAttribute('aria-label', newLabel);
    link.setAttribute('title', newLabel);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer nofollow');

    link.classList.add('external-link');
  });
});
// shop now button aria label
$(document).ready(function () {
  $('.banner__buttons a.button--primary').attr(
    'aria-label',
    'Shop Now all collections '
  );
// for careers button on homepage
 $('.image-with-text__text-item a.button--primary').attr(
    'aria-label',
    'Apply Now for Careers'
  );

});
///back to top
document.addEventListener('DOMContentLoaded', function () {
  var backToTopButton = document.getElementById('back-to-top');
  window.onscroll = function () {
    if (window.pageYOffset > 300) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  };
  backToTopButton.onclick = function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.setTimeout(function () {
      document.getElementById('backtoheader').focus();
    }, 600);
  };
});

// policy page table header issue
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/policies/privacy-policy')) {
    return;
  }

  document.querySelectorAll('table').forEach(function (table) {
    var headerTexts = Array.from(table.querySelectorAll('th'))
      .map(function (th) {
        return th.textContent.trim().toLowerCase();
      });

    var tableText = table.textContent.trim().toLowerCase();

    var isPrivacyTable =
      (
        headerTexts.includes('category') &&
        headerTexts.includes('categories of recipients')
      ) ||
      (
        tableText.includes('category') &&
        tableText.includes('categories of recipients')
      );

    if (!isPrivacyTable) {
      return;
    }

    /* Explicitly identify this as a data table */
    table.setAttribute('role', 'table');
    table.setAttribute(
      'aria-label',
      'Categories of personal information and recipients'
    );

    /* Add proper column-header semantics */
    var firstRow = table.querySelector('tr');

    if (firstRow) {
      firstRow.querySelectorAll('th').forEach(function (th) {
        th.setAttribute('scope', 'col');
      });
    }

    /* Ensure data cells remain data cells */
    table.querySelectorAll('tbody td').forEach(function (td) {
      td.removeAttribute('scope');
      td.removeAttribute('headers');
    });
  });
});
// carteers page aria label
$(document).ready(function () {
  $('a.external-link[aria-label]').each(function () {
    var $link = $(this);
    var text = $link.clone().children('[aria-hidden="true"]').remove().end().text().trim();
    var label = $link.attr('aria-label');

    if (text && label.toLowerCase().indexOf(text.toLowerCase()) === -1) {
      $link.attr('aria-label', text + '. ' + label);
    }
  });
});

// store locatpr page aria label
$(document).ready(function () {
  $('a[aria-label]').each(function () {
    var $link = $(this);
    var text = $link.clone().find('[aria-hidden="true"]').remove().end().text().trim();
    var label = $link.attr('aria-label');

    if (text && !label.toLowerCase().includes(text.toLowerCase())) {
      $link.attr('aria-label', text + '. ' + label);
    }
  });
});